import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms"

export function NumberValidator(): ValidatorFn {
    return (control: AbstractControl): null | ValidationErrors => {
        let regex = /^[-]?[0-9]*\.?[0-9]+$/gm;
        if (control.value) {
            let inputValue = null;
            if (control.value instanceof String) {
                inputValue = control.value.trim();
            } else {
                inputValue = control.value;
            }
            if (!regex.test(inputValue)) {
                console.log("Number validator fail");
                return { "invalidCharacters": true };
            }
        }
        return null;
    }
}
